import { Jenjang } from '../../entities/Jenjang';
import { AxiosResponse } from 'axios';

export class JenjangDataMapper {
  convertListJenjangFromApi(result: AxiosResponse<any>): Jenjang[] {
    const { data } = result.data;
    if (!data || !Array.isArray(data)) {
      return [];
    }
    
    return data.map((item: any) => ({
      jenjang: item.jenjang,
      keterangan: item.keterangan
    }));
  }
}
